<div *ngIf="group">
    <a-dropdown [items]="options" [(ngModel)]="active_duration" placeholder="Select duration..." (ngModelChange)="setValue($event)"></a-dropdown>
</div>
